import * as Yup from "yup"

const dockModel = Yup.object().shape({
  archive: Yup.boolean().required(),
  codename: Yup.string().required(),
  distributionCentre: Yup.mixed().required().label("Distribution Center"),
  id: Yup.string(),
  name: Yup.string().required(),
})
export default dockModel
